import { isEmpty, toLower } from 'lodash';
import { i18n } from '@lt/localization';
import {
  pluralizeAdditional,
  pluralizeLuggage,
} from '../../utils/pluralizeUtils';
import { LUGGAGE_NAME, LUGGAGE_TYPE } from './constants';
import { NBSP } from '../../constants/common';

// TODO: комментарий к багажу позже будет где-то выводиться
export const luggageToArray = (luggage) =>
  Object.entries(luggage || {})
    .filter(([type]) => type !== 'comment')
    .sort(([type1], [type2]) => (type1 < type2 ? -1 : 1));

// Возвращает вес багажа, если количество > 0
export const getLuggageWeight = ({ count, weight }) => count && weight;

export const getLuggageWeightText = (weight, type, options) =>
  weight && options.transportation_type !== 'with_baggage'
    ? `${i18n.t('filters.prices.before')}${NBSP}${weight} ${i18n.t(
        type === LUGGAGE_TYPE.SKI
          ? 'checkout.flight.luggage.weight'
          : 'checkout.flight.luggage.weightForHuman',
      )}`
    : '';

// Текст о количестве багажа
export const getLuggageCountText = (count, type, options) => {
  const luggageType =
    type === LUGGAGE_TYPE.HOLD
      ? LUGGAGE_NAME[LUGGAGE_TYPE.WITHOUT_HOLD]
      : LUGGAGE_NAME[type];

  let luggageText = `${i18n.t(
    'checkout.flight.luggage.noInfo',
  )} ${luggageType}`;

  if (type === LUGGAGE_TYPE.SKI) {
    switch (options.transportation_type) {
      case 'without_equipment': {
        luggageText = i18n.t('checkout.flight.luggage.ski.without_equipment');
        if (options.capitalize === false) {
          luggageText = toLower(luggageText);
        }
        break;
      }
      case 'with_baggage': {
        luggageText = i18n.t('checkout.flight.luggage.ski.with_baggage');
        if (options.capitalize === false) {
          luggageText = toLower(luggageText);
        }
        break;
      }
      case 'additional_space': {
        const additionalText = pluralizeAdditional(count || 1);
        const additionalCount = count ? `${count}` : '';
        const luggage = pluralizeLuggage(count || 1);

        luggageText = [
          additionalCount,
          additionalText,
          luggage,
          i18n.t('checkout.flight.luggage.ski.for'),
          LUGGAGE_NAME[type],
        ].join(NBSP);

        break;
      }
      default: {
        luggageText = '';
      }
    }

    return luggageText;
  }

  if (count > 0) {
    luggageText = `${count}${NBSP}${pluralizeLuggage(count)} ${
      LUGGAGE_NAME[type]
    }`;
  }

  if (count === 0) {
    luggageText = `${i18n.t('checkout.flight.luggage.textNo')} ${
      LUGGAGE_NAME[type]
    }`;
  }

  return luggageText;
};

// Текст о размерах багажа
export const getLuggageSizeText = (size, type, options) => {
  if (isEmpty(size) || options.transportation_type === 'without_equipment') {
    return '';
  }

  if (size[0] === 0) {
    return i18n.t('checkout.flight.luggage.excludingDimensions');
  }

  const isSumOfThreeDimensions = size.length === 1;
  const formattedSize = isSumOfThreeDimensions ? size[0] : size.join('x');
  const postfix = isSumOfThreeDimensions
    ? i18n.t('checkout.flight.luggage.threeDimensions')
    : '';

  return `\n\r${i18n.t('checkout.flight.luggage.size', {
    NBSP: `${NBSP}`,
    size: `${formattedSize}${NBSP}`,
  })} ${postfix}`;
};

// Общий текст про багаж: количество, вес и размер
export const getLuggageText = (
  {
    count,
    weight = 0,
    size = [],
    transportation_type = '',
  }: {
    count?: number;
    weight?: number;
    size?: number[];
    transportation_type?: string;
  },
  type,
  capitalize = true,
) => {
  const text = [
    getLuggageCountText(count, type, { transportation_type, capitalize }),
    count && getLuggageWeightText(weight, type, { transportation_type }),
    count && getLuggageSizeText(size, type, { transportation_type }),
  ];

  return text.filter(Boolean).join(' ');
};
